import { Link } from "gatsby";
import React from "react";

export const CallToActionButton = ({
  label,
  destination,
  fullWidth,
  isActive,
}) => {
  return (
    <Link
      className={`${fullWidth ? "block" : "inline-block"} ${
        isActive ? "cursor-default bg-color-primary-light" : ""
      } font-bold cursor-pointer rounded bg-color-primary w-[140px] text-center text-sm uppercase !text-color-white no-underline transition-colors hover:bg-color-secondary-light py-3`}
      to={destination}
    >
      {label}
    </Link>
  );
};
